export default "__VITE_ASSET__CpUo6RZT__"